import React from 'react';
import One from '../../../images/One.png'
import Two from '../../../images/Two.png'
import Three from '../../../images/Three.png'
import { Carousel } from 'react-bootstrap';

const ProjectCard = (props) => {
    const { title, duration, description, productImgOne, productImgTwo, productImgThree, featureOne, featureTwo, featureThree, featureFour,
        languageOne, languageTwo, languageThree, languageFour, languageFive, languageSix, languageSeven, languageEight, languageNine, languageTen,
        github, server, liveSite, liveSiteAvailable, githubAvailable, serverAvailable } = props.projects;

    return (
        <div>
            <section className="features-service pb-0 pb-md-2 mt-5">
                <div className="container card mb-2">
                    <div class="row g-0">
                        <div class="col-md-7">
                            <Carousel>
                                <Carousel.Item interval={1000}>
                                    <img className="d-block w-100" src={productImgOne} alt="First slide" />
                                </Carousel.Item>
                                <Carousel.Item interval={500}>
                                    <img className="d-block w-100" src={productImgTwo} alt="Second slide" />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img className="d-block w-100" src={productImgThree} alt="Third slide" />
                                </Carousel.Item>
                            </Carousel>
                        </div>
                        {/* <div class="col-md-6">
                            <img src={ComputoriaImageOne} alt="..." {'\8226'} style={{height: '50%'}}/>
                        </div> */}
                        {/* <span style={{fontSize:'20px'}}>&#8226;</span> */}
                        <div class="col-md-5">
                            <div class="card-body">
                                <h2 class="card-title">{title}</h2>
                                <p class="card-text"><small class="text-muted">{duration}</small></p>
                                <h6 class="card-text">{description}</h6>
                                <p class="card-text"><ul class="list-group"> All the facilities of this website are listed here:
                                <li>{featureOne}</li>
                                    <li>{featureTwo}</li>
                                    <li>{featureThree}</li>
                                    <li>{featureFour}</li>
                                </ul></p>
                                <h5><span class="badge bg-light text-muted">{languageOne}</span>
                                    <span class="badge bg-light text-muted">{languageTwo}</span>
                                    <span class="badge bg-light text-muted">{languageThree}</span>
                                    <span class="badge bg-light text-muted">{languageFour}</span>
                                    <span class="badge bg-light text-muted">{languageFive}</span>
                                    <span class="badge bg-light text-muted">{languageSix}</span>
                                    <span class="badge bg-light text-muted">{languageSeven}</span>
                                    <span class="badge bg-light text-muted">{languageEight}</span>
                                    <span class="badge bg-light text-muted">{languageNine}</span>
                                    <span class="badge bg-light text-muted">{languageTen}</span></h5>
                            </div>
                            <div>
                            <button type="submit" className="btn btn-light"><a class="nav-link" href={liveSite} rel="noreferrer" target="_blank">{liveSiteAvailable}</a></button>
                                <button type="submit" className="btn btn-light"><a class="nav-link" href={github} rel="noreferrer" target="_blank">{githubAvailable}</a></button>
                                <button type="submit" className="btn btn-light"><a class="nav-link" href={server} rel="noreferrer" target="_blank">{serverAvailable}</a></button>
                            </div>
                        </div>


                        {/* <div class="card mb-3" style="max-width: 540px;"> */}

                    </div>
                </div>
            </section >
        </div>

    );
};

export default ProjectCard;